module.exports = __webpack_public_path__ + "img/189-Gris Anthracite Lisse.jpg";